module.exports = __webpack_public_path__ + "static/media/un-play.4d80037d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recorded/un-play.png
// module id = 2010
// module chunks = 6